/*
Copyright© Celligence International, LLC - 2026

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { createContext, ReactNode, useContext, useState } from 'react';

type ProctorImportReportsContextValue = {
  processing: boolean;
  setProcessing: React.Dispatch<React.SetStateAction<boolean>>;
};

const ProctorImportReportsContext = createContext<ProctorImportReportsContextValue | null>(null);

type ProctorImportReportsProviderProps = {
  children: ReactNode;
};

const ProctorImportReportsProvider = ({ children }: ProctorImportReportsProviderProps) => {
  const [processing, setProcessing] = useState(false);

  return (
    <ProctorImportReportsContext.Provider
      value={{
        processing,
        setProcessing,
      }}
    >
      {children}
    </ProctorImportReportsContext.Provider>
  );
};

const useProctorImportReportsContext = () => {
  const context = useContext(ProctorImportReportsContext);

  if (!context) {
    throw new Error('useProctorImportReportsContext must be used within ProctorImportReportsProvider');
  }

  return context;
};

export { ProctorImportReportsProvider, useProctorImportReportsContext };
